import { render, staticRenderFns } from "./TarefaStatusForm.vue?vue&type=template&id=4c949fd8&"
import script from "./TarefaStatusForm.vue?vue&type=script&lang=js&"
export * from "./TarefaStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports